import axios from 'axios';
import * as endPoints from '../../Constants/Endpoints'

export function GetBarbers() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Barbers,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetEvents(dateTime) {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Events,
    { 
        params: {dateTime},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetPaymentServiceDetails() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.GetPaymentServiceDetails,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetRoster(dateTime) {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Roster,
    { 
        params: {dateTime},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function PostNotification(notification) {
    const Notification = {
        notification
    }
    return axios.post(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Notification, Notification,
    { 
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function UpdateNotification(id, notification) {
    const Notification = {
        id,
        notification
    }
    return axios.put(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Notification, Notification,
    { 
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetNotifications() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Notification,
    { 
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function DeleteNotification(id) {
    return axios.delete(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Notification,
    {
        params: { id },
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}

export function GetConfig() {
    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.GetConfig,
    {
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}